module.exports = __webpack_public_path__ + "html/subscription-total-price_27e5163b1251376e38599daf42614629.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-total-price.html
// module id = Mu6H
// module chunks = 52